interface AjaxOptions {
  method:
    | 'get'
    | 'post'
    | 'put'
    | 'delete'
    | 'patch'
    | 'head'
    | 'GET'
    | 'POST'
    | 'PUT'
    | 'DELETE'
    | 'PATCH'
    | 'HEAD';
  url: string;
  data: any;
  responseType?: '' | 'arraybuffer' | 'blob' | 'document' | 'json' | 'text';
  onprogress?: (event: ProgressEvent<EventTarget>) => void;
  onProgress?: (event: ProgressEvent<EventTarget>) => void;
  onUploadProgress?: (event: ProgressEvent<EventTarget>) => void;
  headers?: Record<string, string>;
  withCredentials?: boolean;
}

export const _ajax = <T = any>({
  method,
  url,
  data,
  responseType = 'json',
  onprogress,
  onProgress,
  onUploadProgress,
  headers,
  withCredentials,
}: AjaxOptions): Promise<T> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    if (withCredentials) {
      xhr.withCredentials = true;
    }
    xhr.open(method, url);
    const hasOnProgress = typeof onProgress === 'function';
    const hasOnprogress = typeof onprogress === 'function';
    if (hasOnProgress || hasOnprogress) {
      xhr.onprogress = e => {
        if (hasOnProgress) {
          onProgress(e);
        } else if (hasOnprogress) {
          // 兼容onprogress配置
          onprogress(e);
        }
      };
    }
    if (typeof onUploadProgress === 'function') {
      xhr.upload.onprogress = onUploadProgress;
    }
    if (headers) {
      Object.entries(headers).forEach(([key, value]) => {
        xhr.setRequestHeader(key, value);
      });
    }
    xhr.send(data);
    xhr.responseType = responseType;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject(xhr.response);
        }
      }
    };
  });
};
